import { useState } from 'react';
import { toast } from 'react-toastify';
import useMain from '../../../../../hooks/useMain';
import { numberWithCommas, titleCase } from '../../../../../utils/helpers';
import GetUserByEmailForm from './getUserByEmailForm';
import GetUserByUIDForm from './getUserByUIDForm';
import GetUserByWalletForm from './getUserByWalletForm';

const Search = ({ allUsers }) => {
	const { theme } = useMain();
	const [foundUser, setFoundUser] = useState(undefined);
	const handleSearchByEmail = async (formData) => {
		setFoundUser(undefined);
		const user = allUsers.find((u) => u.email === formData.email);
		if (!user) return toast.error('User not found.');
		setFoundUser(user);
	};

	const handleSearchByUID = async (formData) => {
		setFoundUser(undefined);
		const user = allUsers.find((u) => u.id === formData.uid);
		if (!user) return toast.error('User not found.');
		if (!user.mmpDate) return toast.error('User is not a MMP user.');
		setFoundUser(user);
	};

	const handleSearchByWallet = async (formData) => {
		setFoundUser(undefined);
		const user = allUsers.find((u) => u.wallet === formData.wallet);
		if (!user) return toast.error('User not found.');
		setFoundUser(user);
	};

	console.log('foundUser :>> ', foundUser);
	return (
		<div className='my-4 card myCards'>
			<div className='card-body'>
				<>
					<div className='row'>
						<div className='col-12'>
							<div className='fs-3 text-center'>Search User</div>
						</div>
					</div>
					<hr />
					<div className='row'>
						<div className='col-sm-4'>
							<GetUserByEmailForm
								theme={theme}
								onSubmit={handleSearchByEmail}
							/>
						</div>
						<div className='col-sm-4'>
							<GetUserByUIDForm
								theme={theme}
								onSubmit={handleSearchByUID}
							/>
						</div>
						<div className='col-sm-4'>
							<GetUserByWalletForm
								theme={theme}
								onSubmit={handleSearchByWallet}
							/>
						</div>
					</div>

					{foundUser && (
						<>
							<h3 className='my-3 text-center'>Search Result:</h3>
							<hr />
							<div className='row'>
								<div className='col-sm-4 text-start'>
									<ul>
										<li className='mb-1 ml-3'>
											ID: <span className='text-set3'>{foundUser.id}</span>
										</li>
										<li className='mb-1 ml-3'>
											Level:{' '}
											<span className='text-set3'>{foundUser.level}</span>
										</li>
										<li className='mb-1 ml-3'>
											Position:{' '}
											<span className='text-set3'>{foundUser.position}</span>
										</li>
										<li className='mb-1 ml-3'>
											Email:{' '}
											<span className='text-set3'>{foundUser.email}</span>
										</li>
										<li className='mb-1 ml-3'>
											Wallet:{' '}
											<span className='text-set3'>{foundUser.wallet}</span>
										</li>
										<li className='mb-1 ml-3'>
											Sponsor:{' '}
											<span className='text-set3'>{foundUser.sponsor}</span>
										</li>
										<li className='mb-1 ml-3'>
											Is Suspended:{' '}
											<span className='text-set3'>
												{foundUser.isSusspended ? 'Yes' : 'No'}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Class:{' '}
											<span className='text-set3'>
												{titleCase(foundUser.userClass)}
											</span>
										</li>
									</ul>
								</div>

								<div className='col-sm-4 text-start'>
									<ul>
										<li className='mb-1 ml-3'>
											Current Card Amount:{' '}
											<span className='text-set3'>
												$
												{numberWithCommas(
													foundUser.currentCard.totalAmount / 1e6
												)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Current Card:{' '}
											<span className='text-set3'>
												{titleCase(foundUser.currentCard.name)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Total Max Cap:{' '}
											<span className='text-set3'>
												${numberWithCommas(foundUser.maxCap.maxCap / 1e6)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Used Max Cap:{' '}
											<span className='text-set3'>
												$
												{numberWithCommas(
													foundUser.maxCap.usedMaxCap / 1e6
												)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Unpaid left balance:{' '}
											<span className='text-set3'>
												${numberWithCommas(foundUser.L.unPaid / 1e6)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Unpaid right balance:{' '}
											<span className='text-set3'>
												${numberWithCommas(foundUser.R.unPaid / 1e6)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Total left balance:{' '}
											<span className='text-set3'>
												${numberWithCommas(foundUser.L.totalValue / 1e6)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Total right balance:{' '}
											<span className='text-set3'>
												${numberWithCommas(foundUser.R.totalValue / 1e6)}
											</span>
										</li>
									</ul>
								</div>

								<div className='col-sm-4 text-start'>
									<ul>
										<li className='mb-1 ml-3'>
											Flash:{' '}
											<span className='text-set3'>
												{numberWithCommas(foundUser.flash)} times
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Corporate Debt:{' '}
											<span className='text-set3'>
												$
												{numberWithCommas(
													foundUser.debts?.corporate?.amount / 1e6
												)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											Official Debt:{' '}
											<span className='text-set3'>
												$
												{numberWithCommas(
													foundUser.debts?.official?.amount / 1e6
												)}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											BemChain Registration Date:{' '}
											<span className='text-set3'>
												{new Date(
													foundUser.bemchainDate
												).toLocaleDateString()}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											MMP Registration Date:{' '}
											<span className='text-set3'>
												{new Date(foundUser.mmpDate).toLocaleDateString()}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											MMP Package Value:{' '}
											<span className='text-set3'>
												${foundUser.currentPackageValue / 1e6}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											MMI Activation Date:{' '}
											<span className='text-set3'>
												{foundUser.mmiIsActive
													? `${new Date(
															foundUser.mmiDate
													  ).toLocaleDateString()}`
													: 'MMI Inactive'}
											</span>
										</li>
										<li className='mb-1 ml-3'>
											MMI Start Amount:{' '}
											<span className='text-set3'>
												{foundUser.mmiIsActive
													? `$ ${foundUser.mmiStartAmount / 1e6}`
													: 'MMI Inactive'}
											</span>
										</li>
									</ul>
								</div>
							</div>
						</>
					)}
				</>
			</div>
		</div>
	);
};

export default Search;
